/**
 * Whether the user took part in the practice a debrief is about. A debrief
 * without the answer was written before it was asked, about a real conversation.
 */
export function debriefTookPart(debrief: { took_part?: boolean }): boolean {
  return debrief.took_part !== false;
}
